export const notificacionConstants = {
    NOTIFICACION_GETPU_SUCCESS:'NOTIFICACION_GETPU_SUCCESS',
    NOTIFICACION_MARCAR_LEIDAS:'NOTIFICACION_MARCAR_LEIDAS',
    NOTIFICACION_NUEVA:'NOTIFICACION_NUEVA'
};
